/**
 * Prefix for agent crm download/push to crm request id
 */
const AgentCRMDownloadReqPrefix = 'agent-crm-';

export { AgentCRMDownloadReqPrefix };
